<template>
	<div class="publicBox">
		<div class="main">
			<ul class="titleList flexBox">
				<li>邀请记录</li>
			</ul>
		</div>

		<!-- 邀请码区域 -->
		<div class="invite-code-section">
			<div class="invite-code-box">
				<div class="invite-code-label">我的邀请码：</div>
				<div class="invite-code-content">
					<span class="invite-code-text">{{ inviteCode || '加载中...' }}</span>
					<a-button v-if="inviteCode" type="primary" size="small" @click="copyInviteLink">复制链接</a-button>
				</div>
			</div>
		</div>

		<a-table class="publicTable" :columns="columns" :data-source="tableData" :rowKey="res => {return res.id}"
			:pagination="pageData" @change="changePage" :loading="tableLoad">
			<div slot="inviteCode" slot-scope="text, record">
				<a-tag color="blue">{{ text }}</a-tag>
			</div>
			<div slot="inviterBonusAmount" slot-scope="text, record">
				<span style="color: #52c41a;">{{ text }}元</span>
			</div>
			<div slot="inviteeBonusAmount" slot-scope="text, record">
				<span style="color: #faad14;">{{ text }}元</span>
			</div>
		</a-table>
	</div>
</template>

<script>
	export default {
		name: 'InviteRecord',
		components: {},
		data() {
			return {
				tableLoad: false,
				inviteCode: '',
				tableData: [],
				columns: [{
					title: '序号',
					dataIndex: 'id',
					align: 'center',
					customRender: (text, record, index) => {
						return (this.pageData.current - 1) * this.pageData.pageSize + index + 1;
					}
				}, {
					title: '邀请码',
					dataIndex: 'inviteCode',
					scopedSlots: {
						customRender: 'inviteCode'
					},
					align: 'center'
				},{
					title: '参与邀请人',
					dataIndex: 'inviteeUsername',
					scopedSlots: {
						customRender: 'inviteeUsername'
					},
					align: 'center'
				}, {
					title: '邀请奖励',
					dataIndex: 'inviterBonusAmount',
					scopedSlots: {
						customRender: 'inviterBonusAmount'
					},
					align: 'center'
				},{
					title: '邀请时间',
					dataIndex: 'createTime',
					align: 'center'
				}],
				pageData: {
					current: 1,
					pageSize: 10,
					total: 0,
					showLessItems: true,
					showTotal: total => `共 ${total} 条`
				},
			}
		},
		computed: {
			inviteLink() {
				if (!this.inviteCode) return '';
				return `https://sso.cloud-ming.com/sso/sign?inviteCode=${this.inviteCode}`;
			}
		},
		mounted() {
			this.getData();
			this.getInviteCode();
		},
		methods: {
			getInviteCode() {
				this.$reqToken("get", "/api/center/inviteRecord/getInviteCode", {}, true).then((res) => {
					this.inviteCode = res.data;
				}).catch(() => {
					// 处理错误情况
				});
			},
			copyInviteLink() {
				if (!this.inviteCode) return;
				
				const text = this.inviteLink;
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success('邀请链接已复制到剪贴板');
				}).catch(() => {
					this.$message.error('复制失败');
				});
			},
			getData(){
				this.tableLoad = true;
				this.$reqToken("get", "/api/center/inviteRecord/list",{
					pageNum: this.pageData.current,
					pageSize: this.pageData.pageSize,
				},true).then((res) => {
					this.updateTable(res);
					this.tableLoad = false;
				}).catch(() => {
					this.tableLoad = false;
				})
			},
			updateTable(data) {
				this.tableData = data.rows;
				this.pageData.total = data.total;
			},
			changePage(res){
				this.pageData.current = res.current;
				this.getData()
			}
		}
	}
</script>

<style scoped>
	.invite-code-section {
		margin-bottom: 20px;
		padding: 15px;
		background-color: #f8f9fa;
		border-radius: 4px;
		border: 1px solid #e9ecef;
	}
	
	.invite-code-box {
		display: flex;
		align-items: center;
	}
	
	.invite-code-label {
		font-weight: bold;
		margin-right: 10px;
	}
	
	.invite-code-content {
		display: flex;
		align-items: center;
		gap: 10px;
	}
	
	.invite-code-text {
		font-size: 16px;
		font-weight: bold;
		color: #1890ff;
	}
	
</style>